import { Injectable } from '@angular/core';
import { TaskLocation } from '@ml/tasks/types/classes/task-location.class';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { CrudService } from '@ml/shared/services/crud.service';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TaskLocationService extends CrudService<TaskLocation> {
  taskId: number;

  /**
   * Emit values when we add new task locations so the Related Task table and Locations
   * Table can be updated in real time
   */
  private added = new Subject<{
    task: number;
    taskLocations: TaskLocation[];
  }>();

  /**
   * Emit values when we remove task locations so the Related Task table and Locations
   * Table can be updated in real time
   */
  private removed = new Subject<{
    task: number;
    taskLocations: number[];
  }>();

  constructor(private http: HttpClient) {
    super(http, false);
  }

  get url() {
    return `tasks/${this.taskId}/locations`;
  }

  setStatus(taskLocation: TaskLocation): Observable<TaskLocation> {
    const url = `tasks/${taskLocation.task}/locations`;
    const body = {
      status: taskLocation.status
    };
    return this.http.patch<TaskLocation>(`${url}/${taskLocation.id}`, body);
  }

  bulkCreate(taskLocations: TaskLocation[]) {
    return this.http
      .post<TaskLocation[]>(`${this.url}/create`, taskLocations)
      .pipe(
        tap(_taskLocations =>
          this.added.next({
            task: this.taskId,
            taskLocations: _taskLocations
          })
        )
      );
  }

  bulkRemove(taskLocations: number[]) {
    return this.http.post(`${this.url}/remove`, taskLocations).pipe(
      tap(() =>
        this.removed.next({
          task: this.taskId,
          taskLocations
        })
      )
    );
  }

  added$() {
    return this.added.asObservable();
  }

  removed$() {
    return this.removed.asObservable();
  }
}
